import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-white/70 mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={`
            w-full px-4 py-3 bg-white/5 border rounded-xl text-white placeholder-white/40
            transition-all duration-200
            ${error ? 'border-coral' : 'border-white/10 focus:border-turquoise/50'}
            ${className}
          `}
          {...props}
        />
        {error && (
          <p className="mt-2 text-sm text-coral">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
